export default __webpack_public_path__ + "static/media/planet7.8ed80918.png";